var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 300,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 300,
    rx: 6,
    fill: "#F9FAFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 561,
    height: 299,
    rx: 5.5,
    fill: "#F9FAFD",
    stroke: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.8 143.3a3.5 3.5 0 0 0-3.02.22L281 184.3l-74.86-40.83a3.48 3.48 0 0 0-5.14 3.05v76.52a6.96 6.96 0 0 0 6.96 6.96h146.08a6.96 6.96 0 0 0 6.96-6.96v-76.52a3.48 3.48 0 0 0-2.2-3.22Z",
    fill: "#9ED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.84 110.39a3.48 3.48 0 0 0-3.8.75l-33.02 32.94a3.49 3.49 0 0 0 .8 5.51l33.02 18a3.49 3.49 0 0 0 5.14-3.05V113.6a3.48 3.48 0 0 0-2.14-3.21Zm121.12 33.69-33.03-32.94a3.47 3.47 0 0 0-5.93 2.46v50.94a3.48 3.48 0 0 0 5.14 3.05l33.03-18a3.48 3.48 0 0 0 .8-5.51Z",
    fill: "#4075BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 70h-80a6.96 6.96 0 0 0-6.96 6.96v89.64l45.3 24.72a3.49 3.49 0 0 0 3.33 0l45.29-24.72V76.96A6.95 6.95 0 0 0 321 70Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 91.92a71.2 71.2 0 0 0-3.56-1c-2.63-.7-2.91-.84-3.28-1.35a1.15 1.15 0 0 1-.18-.94 1.66 1.66 0 0 1 .77-1.05c.78-.3 1.64-.33 2.43-.07a5.44 5.44 0 0 1 3.47 2.49l6.34-3.03a12.17 12.17 0 0 0-6.68-5.48v-2.8h-7.13v2.38a8.34 8.34 0 0 0-6.19 6.26 7.38 7.38 0 0 0 1.25 5.92c1.89 2.63 4.38 3.29 7.26 4.05.92.24 1.99.52 3.25.91 1.66.51 1.65.6 1.53 1.6a3.72 3.72 0 0 1-2.56 1.5 5.45 5.45 0 0 1-5.04-2.82l-6.12 3.4a13.31 13.31 0 0 0 6.63 5.35V110h7.12v-2.47c3.33-.97 6.63-3.5 7.05-6.97.51-4.27-1.63-7.18-6.36-8.64Zm23.83 49.25h-55.66a3.48 3.48 0 1 1 0-6.96h55.66a3.48 3.48 0 1 1 0 6.96Zm0 15.5h-55.66a3.48 3.48 0 1 1 0-6.95h55.66a3.48 3.48 0 1 1 0 6.95Zm0-31h-55.66a3.47 3.47 0 1 1 0-6.96h55.66a3.48 3.48 0 0 1 0 6.96Z",
    fill: "#CDD9E9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 300,
    rx: 6,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "#fff",
    transform: "translate(201 70)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvoices);
export default __webpack_public_path__ + "static/media/no-invoices.0dc3823e133e1d3664c62ad0769e1401.svg";
export { ForwardRef as ReactComponent };